// SchrankAnsichtPage - Reine Read-Only-Ansicht für alle Mitarbeiter
import React from 'react';
import { Lock, Eye } from 'lucide-react';
import MainLayout from '../components/layout/MainLayout';
import { Badge } from '../components/ui/badge';
import { SchrankViewer } from '../components/schrank/SchrankViewer';

export function SchrankAnsichtPage() {
  return (
    <MainLayout>
      <div className="space-y-4" data-testid="schrank-ansicht-page">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
          <div>
            <h1 className="text-2xl sm:text-3xl font-heading font-bold flex items-center gap-2">
              <Lock className="w-7 h-7 text-primary" />
              Schränke
            </h1>
            <p className="text-sm text-muted-foreground">
              Übersicht aller Gebäude, Etagen und Schrankbelegungen.
            </p>
          </div>
          <Badge variant="outline" className="text-slate-600 border-slate-300 bg-slate-50 w-fit">
            <Eye className="w-3 h-3 mr-1" /> Ansicht
          </Badge>
        </div>
        <SchrankViewer mode="view" canAssign={false} />
      </div>
    </MainLayout>
  );
}

export default SchrankAnsichtPage;
